<div class="profile-content-section" data-cy="hammer-rating-charts-area">
  <ng-container *ngIf="(hammerRatingCount$ | push)! > 0; else noHammerRatings">
    <div class="vti-dial-container">
      <div class="chart-container">
        <div class="vti-header">
          <h2 data-cy="hammer-rating-charts-title">Verified Trade Index (VTI)</h2>
          <div class="flex flex-row justify-content-center align-items-end">
            <img src="assets/images/VTI-imgs/VTI Seal SVG.svg" style="height: 120px; margin: 20px 0 0;"/>
          </div>
        </div>
        <div class="flex flex-col justify-content-end align-items-center" *ngFor="let details of hammerRatingsDetails">
          <span>{{details.category}}</span>
          <img
            [src]="getDialImgPathByRating(details.rating)"
            [alt]="details.category + ' VTI rank: ' + getRankName(details.rating)"
            [attr.data-cy]="details.category + '-vti-rank'"
            style="height: 150px;"
          >
          <!-- TT-273: how long they have worked in this discipline, from their verified claim. -->
          <span
            class="vti-years"
            *ngIf="yearsFor(details.productInstallationTypeId) as years"
            [attr.data-cy]="details.category + '-vti-years'"
          >{{ years }} {{ years === 1 ? 'year' : 'years' }} experience</span>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #noHammerRatings>
    <div class="alert alert__warning text-center" data-cy="empty-hammer-rating-charts">
      No VTI data found for this installer.
    </div>
  </ng-template>
</div>
